import React from 'react';

function CommentIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24">
      <g clipPath="url(#clip0_3999_5053)">
        <path
          fill="#049B56"
          d="M24.152 11.309V24H12.17a12 12 0 1111.982-12.754v.063zM13.152 7h-6v2h6V7zm4 4h-10v2h10v-2zm0 4h-10v2h10v-2z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_3999_5053">
          <path fill="#fff" d="M0 0H24V24H0z" transform="translate(.152)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default CommentIcon;
